module.exports = __webpack_public_path__ + "static/img/business logo.ea336f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/business logo.png
// module id = L3GS
// module chunks = 0